jQuery(document).ready(function(){
  if(jQuery('.product-bundle-block').hasClass('product_bundle_trousers') || jQuery('.product-bundle-block').hasClass('product_bundle_suit')){
    $(".bundle_variant_label").trigger('click');
  }
});

/* Shirt bundle code start */
$(".bundle_variant_label").click(function() {
  $(".bundle_variant_label").removeClass('is-active');
  $(this).addClass('is-active');
  $('.product-bundle-color').addClass('is-active');
  var limitNumber = $(this).attr('data-limit');
  if(limitNumber == 1){
    $('.single_price').show();
    $('.4_shirt_149').hide();
    $('.bedge-price').hide();
    $('#bundle_variant_title').html('Single');
    $('.price-ui-bundle').hide();
    $('.price-ui-normal').show();
  }
  else{
    $('.bedge-price').show();
    $('.single_price').hide();
    $('.4_shirt_149').show();
    $('#bundle_variant_title').html('4-Pack');
    $('.price-ui-bundle').show();
    $('.price-ui-normal').hide();
  }
  var defaultSockImag = 'https://cdn.shopify.com/s/files/1/0269/6727/7651/files/dummy-socks.png?v=1713935564';
  $('#bundle__product_2').val('');
  $('#bundle__product_3').val('');
  $('#bundle__product_4').val('');
  $('.select_color_2').find('.close-cvs').hide();
  $('.select_color_2').find('.cvs-select--color').show();
  $('.select_color_2').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
  
  $('.select_color_3').find('.close-cvs').hide();
  $('.select_color_3').find('.cvs-select--color').show();
  $('.select_color_3').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
  $('.select_color_4').find('.close-cvs').hide();
  $('.select_color_4').find('.cvs-select--color').show();
  $('.select_color_4').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
  for(var t=2;t<=4;t++){
      jQuery('[for="select_color_'+t+'"]').find('.label_active_content').hide();
      jQuery('[for="select_color_'+t+'"]').find('.label_draft_content').show();
  }
  var colorDefault = jQuery('.color-box-wrapper.color-active').text();
  jQuery('#bundle__product_1').attr('data-color',colorDefault);
  var defaultVariantId = jQuery('#variant_default_product').val();
  jQuery('#bundle__product_1').val(defaultVariantId);
  var dataImg = jQuery('#img_default').val();
    
  $('.select_color_label').addClass('selected-variant');
  jQuery('[data-id="select_color_1"]').find('.label_active_content').find('img').attr('src',dataImg);
  
  jQuery('[data-id="select_color_1"]').find('.label_draft_content').hide();
  jQuery('[data-id="select_color_1"]').find('.label_active_content').show();
  if(limitNumber!=1){
      jQuery('.product_remove_one').show();
      $('.ajax-submit').addClass('custom-pack-bundle');
      jQuery('.product-grid-colorswatch').hide();
      $('.product-bundle-color').show();
      var tempStr = '';
      $('.select_color_main').hide();
      for(var i=2; i<=limitNumber; i++){
        $('.select_color_'+i).show();
      }
      
      if(limitNumber == 1){
        $('#bundle__product_2').val('');
        $('#bundle__product_3').val('');
        $('#bundle__product_4').val('');
        $('.select_color_2').find('.close-cvs').hide();
        $('.select_color_2').find('.cvs-select--color').show();
        $('.select_color_2').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
        $('.select_color_3').find('.close-cvs').hide();
        $('.select_color_3').find('.cvs-select--color').show();
        $('.select_color_3').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
        $('.select_color_4').find('.close-cvs').hide();
        $('.select_color_4').find('.cvs-select--color').show();
        $('.select_color_4').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
      }
      if(limitNumber == 2){
        $('#bundle__product_3').val('');
        $('#bundle__product_4').val('');
        $('.select_color_3').find('.close-cvs').hide();
        $('.select_color_3').find('.cvs-select--color').show();
        $('.select_color_3').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
        $('.select_color_4').find('.close-cvs').hide();
        $('.select_color_4').find('.cvs-select--color').show();
        $('.select_color_4').find('.cvs-radio-thumb').find('img').attr('src', defaultSockImag);
      }
      //$('.product-select-all-color').hide();
      $('.product_all_selectbox').hide();
  }/*else if($('.product-bundle-block').hasClass('product-bundle-block_v2')){
      $('.ajax-submit').addClass('custom-pack-bundle');
      $('.product-bundle-color').show();
      $('.product_all_selectbox').hide();
      jQuery('.product_remove_one').hide();
      $('.select_color_main').hide();
      $('.select_color_1').show();
      $('#bundle__product_2').val('');
      $('#bundle__product_3').val('');
      $('#bundle__product_4').val('');
  }*/
  else{
    $('.product-bundle-color').hide();
    jQuery('.product-grid-colorswatch').show();
  }
  selectedColor();
});
/* Shirt bundle code end */

jQuery(window).bind('load',function(){
  if(jQuery('#bundle__product_1').length != 0){
    var bundle__product_1val = jQuery('#variant_default_product').val();
    jQuery('#bundle__product_1').val(bundle__product_1val);
  }
  if(jQuery('.color-box-wrapper.color-active').length!=0){
    var colorGet = jQuery('.color-box-wrapper.color-active').find('.color_name_tooltip').text();
    colorGet=capitalizeFLetter(colorGet);
    jQuery('.bundle_selected_color').eq(0).attr('data-color',colorGet);
    selectedColor();
  }
});
function capitalizeFLetter(string) {
  if(string!=""){
    return (string[0].toUpperCase() + string.slice(1));
  }
}

/* Trouser bundle code start */
$(document).on('click', '.select_color_label', function(e) {
  e.stopPropagation();
  if(jQuery(this).hasClass('trouser_select_label') == false){
    var dataId = $(this).attr('data-id');
    var dataSelidId= $(this).attr('data-selid');
    var packActive = $('.bundle_variant_label.is-active').data('limit');
    if(jQuery('.product_bundle_trousers').length!=0 || jQuery('.product_bundle_suit').length!=0){
      packActive=4;
    }
    if(packActive==4){
      jQuery('.product_remove_one').show();
      $('.select_color_label').removeClass('active');
      $('.select_color_label').removeClass('selected-variant');
      $(this).addClass('active');
      $('#'+dataId).prop('checked','checked');
      var radioId = $('.select_color_label.active').prev('[name="select-color"]').attr('id');
      if(radioId!=undefined){
         removeCheckBox(radioId);
      }else{
        $('.select_color_label.active').prev('[name="select-color"]').prop('checked','checked');
      }
      
      //$('.product-select-all-color').show();
      var activePrev=jQuery('.active_pack').val();
      if(activePrev!=dataId){
        $('.product_all_selectbox').show();
      }else{
        $('.product_all_selectbox').toggle();
      }
      jQuery('.active_pack').val(dataId);
      $('.product-select-all-color-card').attr('data-selid', $(this).attr('data-selid'));
    }else{
      jQuery('.product_remove_one').hide();
    }
  }
});
/* Trouser bundle code end */

function removeCheckBox(radioId) {
  jQuery('.select-color').each(function() {
    if (jQuery(this).attr('id') != radioId) {
      jQuery(this).removeAttr('checked');
    } else {
      if (jQuery('#' + radioId).prop('checked')) {
        jQuery('#' + radioId).removeAttr('checked');
      } else {
        jQuery('#' + radioId).prop('checked', 'checked');
      }
    }
  });
}

//trouser and suit custom bundle start code here

$(document).on('click','.product_bundle_two_pack.product-select-all-color-card',function() {
    var swatchSize = '<div class="swatch_options swatch_options_custom"><div class="swatch is-flex is-flex-wrap " data-option-index="0"> <div class="option_title_custom"><strong>FREE</strong> Trousers Size</div>';
    var productId = jQuery(this).attr('data-pid');
    var dataSelidId = $(this).attr('data-selid');
    var packActive = 4;
    jQuery('.selected-productsize').html('');
    if(packActive==4){
      $('.ajax-submit').addClass('custom-pack-bundle'); 
      jQuery('.product_remove_one').show();
      var checkout=0;
      var defaultVariantID = 0;
      var flagcheck=0;
      var defaultVariantData = [];
      jQuery('.swatch_options .swatch-element').each(function(){
          var valueDefault = jQuery(this).attr('value').replace(/\W+/g, '');
          defaultVariantData.push(valueDefault);
      });
      jQuery(this).find('.variant_class').each(function(e){
        var size = jQuery(this).attr('variant-size').toUpperCase();
        var sizeVal  = jQuery(this).attr('option-val');
        var availSize = jQuery(this).attr('data-available');
        var variantId = jQuery(this).val();
        var checkstr='';
        if(checkout==0){
          checkstr="checked";
          defaultVariantID = variantId;
        }
        var newsize = size.replace(/\W+/g, '');
        if(defaultVariantData.includes(newsize)){
          flagcheck++;
        }
        var disabledSize='';
        if(availSize==false){
          disabledSize='<img class="crossed-out" src="//tailoredathlete.co.uk/cdn/shop/t/130/assets/soldout.png?v=44413085747100446851723444230" aria-label="sold out" alt="sold out">';
        }
        swatchSize+='<div tabindex="0" value="'+size+'" data-value="'+size+'" data-pid="'+productId+'" data-id="'+variantId+'" class="swatch-element bundle-swatch-custom '+checkstr+'"> <label class="size-variant" for="swatch-'+size+variantId+'__main">';
        swatchSize+=sizeVal+disabledSize+'</div>';
        checkout++;
      });
      swatchSize+= '</div></div>';
      var dataImg = $(this).attr('data-img');
      var dataProductId = defaultVariantID;
      var dataColor = $(this).attr('data-color');
      $('#bundle__product_'+dataSelidId).val(dataProductId);
      $('#product_selected_color_'+dataSelidId).val(productId);
      $('#bundle__product_'+dataSelidId).attr("data-color",dataColor);
      if(flagcheck==0){
        jQuery('.selected-productsize').html(swatchSize);
        jQuery('.custom-bundle-trousers').find('.option_title').text('Trouser 1 Size');
      }else{
        var selectedDefault = jQuery('.swatch_options [name="option-0"]:checked').val();
        selectedDefault = selectedDefault.replace(/[_\W]+/g, "").toLowerCase();
        var selectedVariant = jQuery('#'+productId+'__'+selectedDefault).val();
        if(selectedVariant!=undefined){
          $('#bundle__product_2').val(selectedVariant);
        }
        jQuery('.custom-bundle-trousers').find('.option_title').text('Size');
      }
      $('.select_color_label').addClass('selected-variant');
      $('.select_color_label.active').find('.label_active_content').find('img').attr('src',dataImg);
      $('.select_color_label.active').find('.label_draft_content').hide();
      $('.select_color_label.active').find('.label_active_content').show();
      $('.select_color_label.active').find('.product-select-color-close').show();
      $('.select_color_label.active').addClass('fill-product');
      $('.product-select-all-color').hide();
      $('.product_all_selectbox').hide();
      selectedColor();
    }else{
      jQuery('.product_remove_one').hide();
    }
});


$(document).on('click','.product-select-all-color-card',function() {
  var productId = jQuery(this).attr('data-pid');
  var dataSelidId = $(this).attr('data-selid');
  var packActive = $('.bundle_variant_label.is-active').data('limit');
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(packActive==4){
      jQuery('.product_remove_one').show();
      var selectSize = jQuery('.custom-option').find(':selected').attr('data-value').toLowerCase();
      var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
      var dataImg = $(this).attr('data-img');
      var dataProductId = selectedVariantId;
      var dataColor = $(this).attr('data-color');
      //alert(productId+"==="+selectSize+"==="+selectedVariantId+"==="+dataImg+"==="+dataProductId+"==="+dataSelidId+"==="+dataColor)
      $('#bundle__product_'+dataSelidId).val(dataProductId);
      $('#product_selected_color_'+dataSelidId).val(productId);
      $('#bundle__product_'+dataSelidId).attr("data-color",dataColor);
      $('.select_color_label').addClass('selected-variant');
      $('.select_color_label.active').find('.label_active_content').find('img').attr('src',dataImg);
      $('.select_color_label.active').find('.label_draft_content').hide();
      $('.select_color_label.active').find('.label_active_content').show();
      $('.select_color_label.active').find('.product-select-color-close').show();
      $('.select_color_label.active').addClass('fill-product');
      $('.product-select-all-color').hide();
      $('.product_all_selectbox').hide();
      selectedColor();
    }
    else{
      jQuery('.product_remove_one').hide();
    }
  }
});

jQuery(document).on("click",".bundle-swatch-custom",function(){
  var vId = jQuery(this).attr('data-id');
  jQuery('.bundle-swatch-custom').removeClass("checked");
  jQuery(this).addClass("checked");
  jQuery('#bundle__product_2').val(vId);
});


jQuery('.select_color_label').click(function(){
  if(jQuery(this).hasClass('trouser_select_label')==false){
    jQuery('.product-select-all-color-card').show();
    var selVal = jQuery('.swatch_options [name="option-0"]:checked').val().replace(/[_\W]+/g, "");
    var selValLower = selVal.toLowerCase();
    $('.product-select-all-color-card').show();
    $('.'+selValLower+'_not_ava').hide();
    hideNotVariantExist(selValLower);
    jQuery('.product_select_list').each(function(){
      var totalLength=jQuery(this).find('.product_bundle_two_pack[style="display: none;"]').length;
      if(totalLength>0){
        var bundleCount = jQuery(this).find('.product_bundle_two_pack').last().attr("data-pcount");
        if(bundleCount==totalLength){
          jQuery(this).hide();
        }else{
          if(jQuery('.product_bundle_suit').length==0){
            jQuery(this).show();
          }
        }
      }
    });
  }
});
function hideNotVariantExist(selValLower){
  jQuery('.product_bundle_two_pack.product-select-all-color-card').each(function(){
    if(jQuery(this).hasClass('exist-variant')){
      if(jQuery(this).hasClass(selValLower+'_size')==false){
        jQuery(this).hide();
      }
    }
  });
}


function selectedColor(){
  var colorString='';
  var colorArr=[];
  jQuery('.bundle_selected_color').each(function(){
    if(jQuery(this).val()!=""){
      //if(jQuery.inArray(jQuery(this).attr('data-color'), colorArr) == -1){
        var colorGet = jQuery(this).attr('data-color');
        colorGet = capitalizeFLetter(colorGet);
        colorString+=colorGet+', ';
        colorArr.push(jQuery(this).attr('data-color'));
      //}
    }
  });
  if(colorString!=""){
    //if(colorArr.length>1){
      colorString = colorString.replace(/,(\s+)?$/, '');  
      jQuery('.product-bundle-color-heading').show();
      jQuery('.product-bundle-color-heading').find('.color-selected').text(colorString);
    /*}else{
      var colorDefault = jQuery('.color-box-wrapper.color-active').text();
      jQuery('.product-bundle-color-heading').show();
      jQuery('.product-bundle-color-heading').find('.color-selected').text(colorDefault);
    }*/
  } 
}

$('.close-csv').on('click',function(){
  var dataSelidId = $(this).attr('data-selid');
  $('#bundle__product_'+dataSelidId).val('');
  $('#product_selected_color_'+dataSelidId).val('');
  $('.select_color_label').removeClass('active');
  $(this).parent().parent().removeClass('fill-product');
  $('.select_color_label').removeClass('selected-variant');
  
  $(this).parent().hide();
  $('.label_draft_content').show();
  jQuery('.selected-productsize').html('');
  jQuery('.custom-bundle-trousers').find('.option_title').text('Size');
  selectedColor();
  //$(this).parent('.select_color_label').find('img').attr('src',variant_default_img);
});

/*$(document).on('click','.product-select-color-close',function(e){
  $('.label_draft_content').show();
  $('.label_active_content').hide();
});*/

jQuery('.swatch_options .swatch-element').click(function(){
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(jQuery('.bundle_variant_label.is-active').length!=0){
      var selectedSize = jQuery(this).attr('data-value').toLowerCase();
      sizeWiseSelected(selectedSize);
    }
  }else if(jQuery('.bundle-swatch-custom').length!=0){
      if($('#bundle__product_1').val()!=""){
        var selectedVariantId = jQuery(this).attr('data-id');
        $('#bundle__product_1').val(selectedVariantId);
      }
  }else{
      var selVal = jQuery(this).attr('data-value');
      var selValLower = selVal.toLowerCase();
      selValLower=selValLower.replace('-',"");
      $('.product-select-all-color-card').show();
      $('.'+selValLower+'_not_ava').hide();
      $('.'+selValLower+'size').hide();
      var selectedSize = jQuery(this).attr('data-value').toLowerCase();
      selectedSize=selectedSize.replace('-',"");
      sizeWiseSelectedTwo(selectedSize);
  }
});

jQuery(document).ready(function(){
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(jQuery('.bundle_variant_label.is-active').length!=0){
      var selectedSize = jQuery('div.select').find('.custom-option option:selected').attr('data-value');
      sizeWiseSelected(selectedSize);
    }
  }
});

function sizeWiseSelected(selectSize){
  var limitPack = jQuery('.bundle_variant_label.is-active').attr('data-limit');
  for(var p=1;p<=limitPack;p++){
    if($('#bundle__product_'+p).val()!=""){
      var productId = jQuery('#product_selected_color_'+p).val();
      var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
      $('#bundle__product_'+p).val(selectedVariantId);
    }
  }
  jQuery('.selected-swatchval').text(selectSize);
}

function sizeWiseSelectedTwo(selectSize){
  var limitPack =2;
  for(var p=1;p<=limitPack;p++){
    if($('#bundle__product_'+p).val()!=""){
      var productId = jQuery('#product_selected_color_'+p).val();
      if(productId!=undefined){
        var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
        if(selectedVariantId==undefined){
          selectedVariantId='';
          jQuery('.product-select-color-close.close-csv').trigger('click');
        }
        $('#bundle__product_'+p).val(selectedVariantId);
      }
    }
  }
}

jQuery(document).ready(function(){
  if(jQuery('.product_bundle_trousers').length==0 && jQuery('.product_bundle_suit').length==0){
    if(jQuery('.bundle_variant_label.is-active').length!=0){
      var selectedSize = jQuery('div.select').find('.custom-option option:selected').attr('data-value');
      sizeWiseSelected(selectedSize);
    }
  }
});

function sizeWiseSelected(selectSize){
  var limitPack = jQuery('.bundle_variant_label.is-active').attr('data-limit');
  for(var p=1;p<=limitPack;p++){
    if($('#bundle__product_'+p).val()!=""){
      var productId = jQuery('#product_selected_color_'+p).val();
      var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
      $('#bundle__product_'+p).val(selectedVariantId);
    }
  }
  jQuery('.selected-swatchval').text(selectSize);
}

function sizeWiseSelectedTwo(selectSize){
  var limitPack =2;
  for(var p=1;p<=limitPack;p++){
    if($('#bundle__product_'+p).val()!=""){
      var productId = jQuery('#product_selected_color_'+p).val();
      if(productId!=undefined){
        var selectedVariantId = jQuery('#'+productId+'__'+selectSize).val();
        if(selectedVariantId==undefined){
          selectedVariantId='';
          jQuery('.product-select-color-close.close-csv').trigger('click');
        }
        $('#bundle__product_'+p).val(selectedVariantId);
      }
    }
  }
}

var legthArr=[];
var legthArr1=[];

jQuery(window).bind('load',function(){
    setInterval(function(){
      if(jQuery('.bundle_variant_label').length!=0){
        jQuery('.bundle_variant_label').show();
      }
    },1500);
    jQuery('.product-info__title').each(function() {
        var height = jQuery(this).height();
        legthArr1.push(height); 
    });
    var maxValue = Math.max.apply(Math,legthArr1);
    maxValue = Math.round(maxValue);
    jQuery('.product-info__title').each(function() {
        jQuery(this).css('height',maxValue);
        jQuery(this).css('display','block');
    });

  setInterval(function(){
    jQuery('.cpc-color-swatch').each(function() {
        var height = jQuery(this).height();
        legthArr.push(height); 
    });
    var maxValue1 = Math.max.apply(Math,legthArr);  
    maxValue1 = Math.round(maxValue1);
    jQuery('.cpc-color-swatch').each(function() {
        jQuery(this).css('height',maxValue1);
    });
    },1500);
});

/* bundle page js start */
jQuery('.bb_product__imgbox').click(function(){
  var popupPid = $(this).attr('data-pid');
  var productUrl = $(this).attr('data-url');

  //$('.popup__loader').addClass('loader__active');
  $('.popup_loader__box').addClass('loader__active');
  $('.bundle_builder_popup').attr('id', 'bundle_builder_popup_'+popupPid);
  $('.bundle_builder_popup').attr('data-pid', popupPid);
  jQuery.ajax({
    url: productUrl,
    type: 'GET',
    success: function(response) {
      var newContentHTML = response['ajax-product-popup-bundle'];
      // Create a temporary container to parse the new HTML content

      $('.bundle_builder_popupbox').html('');
      $('.bundle_builder_popupbox').append(newContentHTML);

      $('body').addClass('bundle_popup_open');
      $('#bundle_builder_popup_'+popupPid).show();
      //$('.popup__loader').removeClass('loader__active');
      $('.popup_loader__box').removeClass('loader__active');
    },
    error: function(xhr, status, error) {
      console.error('AJAX Error:');
    }
  });
  
  //$('#bundle_builder_popup_'+popupPid).addClass("open-popup");
  
});

jQuery(document).on('click','.bundle_popup_swatch',function(){
  var popupPid = $(this).attr('data-pid');
  $('body').addClass('bundle_popup_open');
  $('.bundle_builder_popup').attr('id', 'bundle_builder_popup_'+popupPid);
  $('.bundle_builder_popup').attr('data-pid', popupPid);
  $('.bb_popup_details').hide();
  $('.bb_popup_details__'+popupPid).show();
  $('.bb_popup_details').removeClass("open-popup");
  $('.bb_popup_details__'+popupPid).addClass("open-popup");
  // $('.bundle_builder_popup').hide();
  // $('.bundle_builder_popup').removeClass("open-popup");
  // $('#bundle_builder_popup_'+popupPid).addClass("open-popup");
  // $('#bundle_builder_popup_'+popupPid).show();
});

jQuery(document).on('click','.bb_popup_closebtn',function(){
  $('body').removeClass('bundle_popup_open');
  $('.bundle_builder_popupbox').html('');
  $('.bundle_builder_popup').hide();
  jQuery('.selected-productsize').html('');
});

$(document).ready(function() {
  $('.bb_nav_list').on('click', function() {
    var target = $(this).data('target');
    var targetOffset = $('#' + target).offset().top;

    $('html, body').animate({
        scrollTop: targetOffset
    }, 500); // Adjust the duration as needed
  });
});
/* bundle page js end */

let bundleProductArr = [];
//deleteCookie('zipcode_set');
jQuery(document).on('click','.open-popup .bb_popup_atcbtn',function(e){
    e.preventDefault();
    e.stopPropagation();
    var productId = jQuery('.bb_popup_details.open-popup').data('pid');
    var variantId = jQuery('.bb_popup_details.open-popup').find('[name="radio-'+productId+'"]:checked').attr('data-id');
  
    var ptitle = jQuery('.bb_popup_details.open-popup').find('.bb_popup_title').text();
    var variant_qnt=parseInt(jQuery('.bb_popup_details.open-popup').find('.bundle_qunatity').val());
    var pimage = jQuery('.bb_popup_details.open-popup .bb_popup_img').find('img').attr('src');
    if (!variantExists(bundleProductArr, variantId)) {
        bundleProductArr.push({
            product_id: productId, 
            variant_id: variantId,
            quantity: variant_qnt,
            title: ptitle,
            product_image: pimage
        });
    } else {
        for (var r = 0; r < bundleProductArr.length; r++) {
            if (bundleProductArr[r] !== undefined && bundleProductArr[r].variant_id === variantId) {
                bundleProductArr[r].quantity = parseInt(bundleProductArr[r].quantity) + parseInt(variant_qnt);
                break; // Exit loop after updating the quantity
            }
        }
    }
    addBundlelist();
});

function addBundlelist(){
  if(bundleProductArr.length>0){
      var bundleProductData=bundleProductArr;
      var productBundleData = bundleProductArr;
    
      let variantCount = 0;
      var bundleCollection = '';
      var showslide = 0;
      var productBoxcounter = 1;
      var productGroup = []; // Array to hold groups of five products
      var productMain=0;
      for (var y = 0; y < productBundleData.length; y++) {
          var imagesrc = '';
          if (productBundleData[y] != undefined) {
              var productImage = productBundleData[y].product_image;
              var productTitle = productBundleData[y].title;
              var productId = productBundleData[y].product_id;
              var variantId = productBundleData[y].variant_id;
              var quantity = productBundleData[y].quantity;
      
              var productHTML = '<div class="bb_checkout_list product-fill-box bundle_add_' + variantId + '">';
              productHTML += '<div class="bb_checklist_full">';
              productHTML += '<img src="' + productImage + '"><div class="bb_check_remove" data-vid="' + variantId + '">';
              productHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">';
              productHTML += '<path d="M6 1.36194V10.6383" stroke="#2E2520" stroke-width="1.5" stroke-linecap="round"/></path>';
              productHTML += '<path d="M10.5 5.98022H1.5" stroke="#2E2520" stroke-width="1.5" stroke-linecap="round"/></path>';
              productHTML += '</svg></div>';
              if (parseInt(quantity) > 1) {
                  productHTML += '<div class="bb_check_productquanti"><span>' + quantity + '</span></div>';
              }
              productHTML += '</div></div>';
              productGroup.push(productHTML);
              showslide++;
              imagesrc=productImage;
              productMain++;
              variantCount+=quantity;
          }
      
          // Check if we have collected 5 products
          if (showslide == 5 || y == productBundleData.length - 1) {
              var groupHTML = '<div class="bundle-bunch"' + (showslide==5 ? ' style="display:none;"' : '') + '>';
              groupHTML += productGroup.join('') + '</div>';
              bundleCollection += groupHTML;
              productGroup = []; // Reset for next group
          }
          if(y==4){
             bundleCollection+='<div class="bb_checkout_list bundle_full_box bundle_add_'+variantId+'">';
             bundleCollection+='<div class="image_section"><div class="show_all_qnt"><span class="count-products">'+productMain+'</span></div>';
             bundleCollection+='<div class="bb_checklist_full">';
             bundleCollection+='<img src="'+imagesrc+'"></div></div>';
             bundleCollection+='</div>';
          }
          if (showslide == 5){
            showslide = 0;
          }
      
          productBoxcounter++;
      }
      
      // Handle the case where the number of products is less than 5
      if (productBundleData.length > 0 && productBundleData.length < 5) {
          var endloop = (5 - showslide);
          for (var t = 0; t < endloop; t++) {
              bundleCollection += '<div class="bb_checkout_list top"><div class="bb_checklist_blank"><span>' + productBoxcounter + '</span></div></div>';
              productBoxcounter++;
          }
      } else if (productBundleData.length > 0 && showslide != 0) {
          var endloop = (5 - showslide);
          for (var t = 0; t < endloop; t++) {
              bundleCollection += '<div class="bb_checkout_list top-second"><div class="bb_checklist_blank"><span>' + productBoxcounter + '</span></div></div>';
              productBoxcounter++;
          }
      } else if (productBundleData.length >= 5 && showslide == 0) {
          for (var w = showslide; w < 5; w++) {
              bundleCollection += '<div class="bb_checkout_list bottom"><div class="bb_checklist_blank"><span>' + productBoxcounter + '</span></div></div>';
              productBoxcounter++;
          }
      }
      
      jQuery('.bb_checkout_listbox').html(bundleCollection);
      jQuery('.bb_checkout_btn_list span').text(variantCount);
      if(jQuery('.count-products').length>0){
        jQuery('.count-products').text(productMain);
      }
      var firstitems=6;
      var seconditems=9;
      var thirditems=12;
      var ramainProduct=0;
      var percentage = parseInt(100/thirditems);
      var percentageWidth=0;
      if(firstitems>variantCount){
        ramainProduct = (firstitems-variantCount);
        percentageWidth = (percentage*variantCount);
        jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.bb_progress_filled').css('width',percentageWidth+'%');
        jQuery('.percent-text').text('45%');
        jQuery('.saveoff-full').hide();
        jQuery('.saveoff').show();
      }else if(seconditems>variantCount){
        ramainProduct = (seconditems-variantCount);
        percentageWidth = (percentage*variantCount);
        jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.bb_progress_filled').css('width',percentageWidth+'%');
        jQuery('.percent-text').text('50%');
        jQuery('.saveoff-full').hide();
        jQuery('.saveoff').show();
      }else if(thirditems>variantCount){
        ramainProduct = (thirditems-variantCount);
        percentageWidth = (percentage*variantCount);
        jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.bb_progress_filled').css('width',percentageWidth+'%');
        jQuery('.percent-text').text('55%');
        jQuery('.saveoff-full').hide();
        jQuery('.saveoff').show();
      }else if(variantCount>=thirditems){
        //jQuery('.bb_progress_title .progress-count').text(ramainProduct);
        jQuery('.saveoff').hide();
        jQuery('.saveoff-full').show();
        jQuery('.bb_progress_filled').css('width','100%');
      }
  }else{
    var bundleCollection='';
    for (var t = 1; t <= 5; t++) {
          bundleCollection += '<div class="bb_checkout_list top"><div class="bb_checklist_blank"><span>' +t+ '</span></div></div>';
          productBoxcounter++;
    }
    jQuery('.bb_checkout_listbox').html(bundleCollection);
    jQuery('.bb_checkout_btn_list span').text(0);
    jQuery('.count-products').text(0);
    jQuery('.saveoff').show();
    jQuery('.saveoff-full').hide();
    jQuery('.bb_progress_title .progress-count').text(6);
    jQuery('.bb_progress_filled').css('width','0%');
  }
}

jQuery(document).on("click",".bb_check_remove",function(){
  //console.log("remove",jQuery(this).data('vid'));
  var variantId = jQuery(this).data('vid');
  //console.log("bundleProductArr",bundleProductArr);
  if(variantId!="" && variantId!=undefined){
    //console.log("variantId",variantId);
    jQuery('.bundle_add_'+variantId).remove();
    bundleProductArr = removeVariantId(bundleProductArr, variantId);
    addBundlelist();
  }
});

jQuery(document).on("click",".bundle_full_box",function(){
  jQuery('.bundle-bunch').show();
  jQuery('.image_section').hide();
  if(jQuery('.hide_link_box').length>0){
    jQuery('.hide_link_box').remove();
  }
  if(jQuery('.bb_checkout_list.bottom').length>0){
    jQuery('.bb_checkout_list.bottom').hide();
  }
  jQuery(this).hide();
  jQuery('.top-second').hide();
  var stringHide = '<div class="hide_link_box"><span>Hide items</span></div>';
  jQuery('.bundle-bunch').last().append(stringHide);
});

jQuery(document).on("click",".hide_link_box",function(){
  jQuery('.bundle_full_box').show();
  jQuery('.top-second').show();
  if(jQuery('.bb_checkout_list.bottom').length>0){
    jQuery('.bb_checkout_list.bottom').show();
  }
  if(jQuery('.bundle-bunch').length==1){
    jQuery('.bundle-bunch').hide();
  }else{
    jQuery('.bundle-bunch').hide();
    if(jQuery('.bb_checklist_blank').length!=5){
      jQuery('.bundle-bunch').last().show();
    }
  }
  jQuery('.image_section').show();
  jQuery(this).remove();
});

jQuery(document).on("click",".bb_checkout_btn",function(){
  if(bundleProductArr.length>0){
    jQuery('.check-button-bb').hide();
    jQuery('.upv-loading').show();
    var itemArr=[];
    for(var d=0;d<bundleProductArr.length;d++){
      if(bundleProductArr[d].variant_id!=undefined){
          itemArr.push({
              id: bundleProductArr[d].variant_id,
              quantity: bundleProductArr[d].quantity,
              properties: {
                _bundle:1,
                _bundleType:'bundle_page'
              }
          });
      }
    }
    if(itemArr.length>0){
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {items:itemArr},
        beforeSend() {
          //curbutton.addClass('is-loading');
          //curbutton.attr('disabled', 'disabled').addClass('disabled');
        },
        success(res) {
          
          //window.location="/checkout";
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              //console.log("GET CART: ", cart);
              // setTimeout(function () {
              refreshCart(cart);
              if ($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }

              openMiniCart();

               $('body').removeClass('bundle_popup_open');
                $('.bundle_builder_popupbox').html('');
                $('.bundle_builder_popup').hide();
                jQuery('.selected-productsize').html('');

              if ($('#header').is(':visible')) {
                $('#header .cart-container').addClass('active_link');
              } 
              else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart-container').addClass('active_link');
              } 
              else {
                $('.top-bar .cart-container').addClass('active_link');
              }

              jQuery('.check-button-bb').show();
              jQuery('.upv-loading').hide();
              // block scrolling on mobile
              if (window.PXUTheme.media_queries.medium.matches) {
                const $cartContainer = $(this).parent();
                if ($cartContainer.hasClass('active_link')) {
                  $('body').addClass('blocked-scroll');
                } else {
                  $('body').addClass('blocked-scroll');
                }

                // Scroll to the top of the page unless the header is fixed
                const header = document.getElementById('header');
                if (header.classList.contains('mobile_nav-fixed--false')) {
                  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                }
              }
            },
          });
        },
        error(XMLHttpRequest) {
          
        },
      });
    }
  }
});


var openMiniCart = function () {
    //console.log("kkkkk");
    window.mobileMenuDrawer.close();
    $('.dropdown_link').removeClass('active_link');
    $('.cart-container').addClass('active_link');
    $('.cart-drawer-overlay').addClass('active_link');
    $('.tos_warning.cart_content').removeClass('fadeOutr');
    $('.tos_warning.cart_content').addClass('fadeInd');
    jQuery('body').addClass('blocked-scroll');
  };

function removeVariantId(arr, variantId) {
    var filteredArray = arr.filter(function(item) {
        return parseInt(item.variant_id) !== parseInt(variantId);
    });
    return filteredArray;
}

function variantExists(array, variantId) {
    return array.some(item => item.variant_id === variantId);
}

$(document).ready(function(){
  $('.bundle_builder_nav').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 4.1,
    slidesToScroll: 1,
    responsive: [
      {
         breakpoint: 9999,
         settings: "unslick"
      },
      {
        breakpoint: 612,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: true
        }
      }
   ]
  });
}); 

/************* PRODUCT DETAILS PAGE SIZE [shipphours] timing EST STRAT **************/
function startCountdown() {
    const now = new Date();
    const estOffset = -5 * 60; // EST offset in minutes
    const utcNow = now.getTime() + now.getTimezoneOffset() * 60000;
    const estNow = new Date(utcNow + estOffset * 60000);

    let targetTime = new Date(estNow);
    targetTime.setHours(12, 0, 0, 0); // Set to 12:00 PM EST

    if (estNow.getHours() >= 12) {
        // If it's after 12:00 PM EST, set target to tomorrow's 12:00 PM EST
        targetTime.setDate(targetTime.getDate() + 1);
    }

    function updateTimer() {
        const now = new Date();
        const utcNow = now.getTime() + now.getTimezoneOffset() * 60000;
        const estNow = new Date(utcNow + estOffset * 60000);

        let timeDiff = targetTime - estNow;
        if (timeDiff <= 0) {
            startCountdown(); // Restart countdown when it reaches 0
            return;
        }

        let hours = Math.floor(timeDiff / 3600000);
        let minutes = Math.floor((timeDiff % 3600000) / 60000);
        let seconds = Math.floor((timeDiff % 60000) / 1000);

        document.getElementById("countdown").textContent =
            `${hours} hours`;
        //${minutes}m ${seconds}s

        setTimeout(updateTimer, 1000);
    }

    updateTimer();
}

let countdownEl = document.getElementById("countdown");
if (countdownEl) {
  document.addEventListener("DOMContentLoaded", startCountdown);
}

/************* PRODUCT DETAILS PAGE SIZE [shipphours] timing EST END **************/

/************************ landing featured product JS START **************************/
jQuery(document).ready(function() {
  jQuery(".fp-accordian > .fp-accordian-heading").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".fp-accordian-content")
        .slideUp(200);
      jQuery(".fp-accordian > .fp-accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      jQuery(".fp-accordian > .fp-accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".fp-accordian > .fp-accordian-heading").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".fp-accordian-content").slideUp(200);
      jQuery(this)
        .siblings(".fp-accordian-content")
        .slideDown(200);
    }
  });
});

/************************ landing featured product JS END **************************/

// =======================================================
/* Hero slider || sections/hero-slider.liquid -- START  */

jQuery(document).ready(function() {
  jQuery('.heroslider-slick').slick({
    dots: true,
    autoplay: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 19.03125 4.28125 L 8.03125 15.28125 L 7.34375 16 L 8.03125 16.71875 L 19.03125 27.71875 L 20.46875 26.28125 L 10.1875 16 L 20.46875 5.71875 Z"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 Z"/></svg></button>',
  });
});

/* Hero slider || sections/hero-slider.liquid -- START  */
// =======================================================

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TESTIMONIALS JS -- START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
$(document).ready(function () {
  if(jQuery('.testimonial-section').find('.testimonial-wrap').length>0){
    var sliderInterId = setInterval(function(){
      if(!$('.testimonial-wrap').hasClass('slick-initialized')){
        $('.testimonial-wrap').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [
           {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              dots: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              dots: true,
            },
          },
          ],
        });
        clearInterval(sliderInterId);
        sameHeightTestimonial();
      }
    },100);
  }
});
function sameHeightTestimonial(){
  var legthArr=[];
  if(jQuery('.testimonial-section .testimonial-wrap').find('.slick-slide').length>0){
    jQuery('.testimonial-section .testimonial-wrap').find('.main-inner-review').each(function() {
        var height = jQuery(this).outerHeight();
        legthArr.push(height);
    });
    var maxValue = Math.max.apply(Math,legthArr);
    maxValue = Math.round(maxValue);
    jQuery('.testimonial-section .testimonial-wrap').find('.main-inner-review').each(function() {
        jQuery(this).css('height',maxValue);
    });
  }
}
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TESTIMONIALS JS -- END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/*************************** PRODUCT DETAILS PAGE SIZE BUTTON CLICK EVENT START *****************************/

jQuery(document).on("click", ".size-button-section .size-buttons", function (e) {
    var headerHeight = jQuery('.shopify-section--header').find('.mobile_nav-fixed--true').height();
    headerHeight = parseInt(headerHeight);
    jQuery('html,body').animate({
        scrollTop: (jQuery('.product-block.product-block--title').offset().top - headerHeight)
    }, 100);
    e.preventDefault();
});

// jQuery('body').addClass('pdp-button-size-v1');
// jQuery('body').addClass('pdp-button-size-v2');

jQuery(window).on("scroll", function () {
    if(jQuery(".purchase-details").find('.add_to_cart').length>0){
      const target = jQuery(".purchase-details").find('.add_to_cart');
      const hideshowSize = jQuery(".size-button-section");
      const windowHeight = jQuery(window).height();
      const scrollTop = jQuery(window).scrollTop();
      const elementOffset = target.offset().top;
  
      if (jQuery('body').hasClass('pdp-button-size-v1')) {
          if (scrollTop + windowHeight > elementOffset && scrollTop < elementOffset + target.height()) {
              hideshowSize.hide();
          } else {
              hideshowSize.show();
          }
      } else if (jQuery('body').hasClass('pdp-button-size-v2')) {
          if (scrollTop + windowHeight > elementOffset) {
              hideshowSize.hide();
          } else {
              hideshowSize.show();
          }
      }
    }
});



/*************************** PRODUCT DETAILS PAGE SIZE BUTTON CLICK EVENT END *******************************/